import React from 'react';
import ModelViewer from '../../ModelViewer';
import { SHOW_MODEL_TOOLBAR } from '../../../config/experiment';
import { useCachedImage } from '../CachedImage';

// デッサン風画像の表示枠。準備中／読み込めないときのプレースホルダを共通化。
// 画像は先読みしたものから出し、読めなければ再試行する（useCachedImage）
function DrawingImageSlot({ src, alt, loading }) {
  const { src: ready, failed } = useCachedImage(loading ? null : src);
  if (loading || (!ready && !failed)) {
    return (
      <div className="shape-step__placeholder">
        <p>画像を準備しています...</p>
      </div>
    );
  }
  if (!ready) {
    return (
      <div className="shape-step__placeholder">
        <p>画像を読み込めませんでした。通信が戻ると表示されます</p>
      </div>
    );
  }
  return <img key={ready} src={ready} alt={alt} />;
}

// ShapeChange（形状変更演習）の1ステップ分（誤り／中間／モチーフ）の表示。
// デッサンと3Dモデルは**横並び**にして縦の積み上がりを解消し、そのぶん両方を大きく見せる。
// 2つのメディア枠は同じ高さ（--step-media-h）・等幅セルで揃えるので、見比べる絵どうしは
// 常に同寸になる。ModelViewer 下部のツールバーはこの枠の外（下）に出るため、
// ツールバーを消しても消さなくても2枚の絵の大きさは変わらない。
// ステップ間の差分（モデル名・canvasId・shearValue 等）は viewerProps として受け取る。
// viewerRef：3Dモデルのカメラを命令的に動かすための ref（ShapeChange のヒント用）
function ShapeStepColumn({ label, drawingImage, imagesLoading, viewerProps, viewerRef = null }) {
  return (
    <div className="shape-step">
      <h2 className="heading-lg shape-step__label">{label}</h2>
      <div className="shape-step__row">
        <div className="shape-step__cell">
          <h3 className="text-subtitle shape-step__caption">デッサン</h3>
          <div className="shape-step__media">
            <DrawingImageSlot src={drawingImage} alt={`${label} デッサン`} loading={imagesLoading} />
          </div>
        </div>
        <div className="shape-step__cell">
          <h3 className="text-subtitle shape-step__caption">3Dモデル</h3>
          <div className="shape-step__media shape-step__media--model">
            <ModelViewer {...viewerProps} ref={viewerRef} showToolbar={SHOW_MODEL_TOOLBAR} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShapeStepColumn;
